import {EgretLoadable} from "egret";

const Interlaken = EgretLoadable({
  loader: () => import('./@InterlakenLayout/InterlakenLayout')
});

export const EgretLayouts = {
  interlaken: Interlaken,
}